import { useConversationKeywords } from '@hooks/settings/conversation-keywords/useConversationKeywords';
import { useConversationKeywordsActions } from '@hooks/settings/conversation-keywords/useConversationKeywordsActions';
import type React from 'react';
import { KeywordDataModal } from './KeywordDataModal';

export const CreateKeywordModal: React.FC = () => {
  const { createConversationKeyword } = useConversationKeywordsActions();
  const { keywords } = useConversationKeywords();

  // Use the current keyword pool from the store for duplicate validation
  const existingKeywords = keywords.map((keyword) => keyword.keyword);

  const handleSubmit = async (keyword: string) => {
    await createConversationKeyword(keyword);
  };

  return (
    <KeywordDataModal
      onSubmit={handleSubmit}
      existingKeywords={existingKeywords}
    />
  );
};

export default CreateKeywordModal;
